export enum MixpanelEvents {
	AnalyticsBuilderDashboards = 'Builder dashboards page',
	AnalyticsComplexChartParams = 'Analytics complex chart param change',
	AnalyticsComplexChartSettingsUpdate = 'Analytics complex chart settings update',
	AnalyticsComplexExcel = 'Analytics complex excel download',
	AnalyticsComplexExcelExpanded = 'Analytics complex excel expanded download',
	AnalyticsComplexFilters = 'Analytics complex filters apply',
	AnalyticsComplexPage = 'Analytics complex page',
	AnalyticsComplexSectionChange = 'Analytics complex change section',
	AnalyticsLaidProductsChartParams = 'Analytics laid products chart param change',
	AnalyticsLaidProductsChartSettingsUpdate = 'Analytics laid products chart settings update',
	AnalyticsLaidProductsExcel = 'Analytics laid products excel download',
	AnalyticsLaidProductsExcelExpanded = 'Analytics laid products excel expanded download',
	AnalyticsLaidProductsFilters = 'Analytics laid products filters apply',
	AnalyticsLaidProductsPage = 'Analytics laid products page',
	AnalyticsLaidProductsSectionChange = 'Analytics laid products change section',
	AnalyticsProductHolesChartParams = 'Analytics product holes chart param change',
	AnalyticsProductHolesChartSettingsUpdate = 'Analytics product holes chart settings update',
	AnalyticsProductHolesExcel = 'Analytics product holes excel download',
	AnalyticsProductHolesExcelExpanded = 'Analytics product holes excel expanded download',
	AnalyticsProductHolesFilters = 'Analytics product holes filters apply',
	AnalyticsProductHolesPage = 'Analytics product holes page',
	AnalyticsProductHolesSectionChange = 'Analytics product holes change section',
	AnalyticsProductHolesDetails = 'Analytics product holes modal details',
	AnalyticsProductHolesGoTo = 'Analytics product holes modal go to',
	ArbitraryLayout = 'Arbitrary layout',
	AutoLayout = 'Auto layout',
	BarChartDownload = 'Bar chart image download',
	BlockedFunctionalPage = 'Blocked functional page',
	BookPresentation = 'Book a presentation',
	BrandsStatistics = 'Brand statistics stand edit',
	ChooseTariff = 'Choose tariff',
	ConfirmPhotoReportsFromControl = 'Confirm photo reports on control',
	ConfirmPhotoReportsFromPlanogram = 'Confirm photo reports on stand view',
	ControlPage = 'Control page',
	DemoAssortmentChange = 'Change demo assortment',
	DemoAssortmentCreate = 'Create demo assortment',
	DemoCategoriesSelect = 'Select demo categories',
	DemoDocumentationLink = 'Demo documentation link',
	DemoTutorialLink = 'Demo tutorial link',
	DemoTutorialVideo = 'Demo tutorial video',
	DownloadPlanogramConfiguration = 'Download configuration on planogram',
	DownloadPlanogramReport = 'Download report on planogram',
	EffectivenessAnalysis = 'Product effectiveness analysis stand edit',
	EquipmentEditCancel = 'Cancel changing equipment',
	EquipmentEditFromPlanogram = 'Changing the equipment',
	EquipmentEditOnPlanogram = 'Changing the equipment on planogram',
	EquipmentSaveAsNew = 'Save as new equipment',
	EquipmentSaveAsNewFromPlanogram = 'Save as new equipment from planogram',
	EquipmentSaveCurrent = 'Replace current equipment',
	EquipmentSaveCurrentFromPlanogram = 'Replace current equipment from planogram',
	EquipmentUploadSuccess = 'Equipment excel upload success',
	GenerateRule = 'Generate ai.rule',
	GenerateRuleInfo = 'Click ai.rule info',
	GenerateRulePreset = 'Use ai.rule preset',
	GenerateRuleReaction = 'Click ai.rule reaction',
	Helpdesk = 'Open Helpdesk',
	HighlightProductsOnPlanogramEdit = 'Highlight products on planogram edit',
	HighlightProductsOnPlanogramView = 'Highlight products on planogram view',
	HighlightProductsOnControl = 'Highlight products on control',
	HomePage = 'Home page',
	IslandRackOpen = 'Open island rack template',
	IslandRackCreate = 'Create island rack from template',
	LayoutHistorySendMessage = 'Stand log send message',
	LayoutRuleBlocked = 'Rule feature blocked',
	LayoutRuleCreate = 'Create rule',
	LayoutRuleDrop = 'Dropped rule on stand',
	LayoutRuleRequested = 'Rule feature requested',
	LayoutRuleSave = 'Saved rule',
	MasterRuleBlocked = 'Master rule feature blocked',
	MasterRuleRequested = 'Master rule feature requested',
	MasterPositionCreate = 'Master position create',
	MirrorLayoutFromPlanogramEdit = 'Mirror layout on stand edit',
	OnboardingCreateEquipment = 'Onboarding create equipment',
	OnboardingCreatePlan = 'Onboarding create plan',
	OnboardingCreatePlanogram = 'Onboarding create planogram',
	OnboardingFullVersion = 'Onboarding full version',
	OnboardingPlacePlanogram = 'Onboarding place planogram',
	OnboardingSavePlan = 'Onboarding save plan',
	OpenEquipmentEdit = 'Open equipment edit',
	OpenEquipmentList = 'Open equipment list',
	OpenEquipmentView = 'Open equipment view',
	OpenEquipmentUpload = 'Open equipment upload',
	OpenPlanogramEdit = 'Open planogram edit',
	OpenPlanogramGroupEdit = 'Open planogram group edit',
	OpenPlanogramGroupView = 'Open planogram group view',
	OpenPlanogramsList = 'Open planograms list',
	OpenPlanogramView = 'Open planogram view',
	OpenStorePlanEdit = 'Open plan edit',
	OpenStorePlansList = 'Open plans list',
	OpenStorePlanView = 'Open plan view',
	PayTariff = 'Pay tariff',
	PersonalSettingsApply = 'Personal settings apply',
	PersonalSettingsOpen = 'Personal settings open',
	PlacedPlanogramsOnPlanView = 'Placed planograms on plan view',
	PlanCompareAnalytics = 'Analytics on plans compare',
	PlanCompareFromList = 'Plan compare on plan list',
	PlanCompareFromView = 'Plan compare on plan view',
	PlanConfiguration = 'Plan complectation',
	PlanDistributionAnalysis = 'Discrete / Continuous Distribution plan view',
	PlanLaidProductsAnalysis = 'Analysis of laid out products plan view',
	PlanMultiComplectationFromList = 'Multi plans equipments from plan list',
	PlanogramABCAnalysis = 'ABC analysis stand view',
	PlanogramConfiguration = 'Stand complectation',
	PlanogramCompareAnalytics = 'Analytics on planograms compare',
	PlanogramCompareFromList = 'Stand compare on stand list',
	PlanogramCompareFromView = 'Stand compare on stand view',
	PlanogramCopyingFromEdit = 'Copying stand on stand edit',
	PlanogramCopyingFromList = 'Copying stand on stand list',
	PlanogramDeletingFromList = 'Deleting planogram from planogram list',
	PlanogramDistributionAnalysis = 'Discrete / Continuous Distribution stand view',
	PlanogramExecutionWithTimeTracker = 'Execution stand with time tracker',
	PlanogramGroupCreate = 'Create planogram group',
	PlanogramGroupPanelOpen = 'Open planogram group panel',
	PlanogramGroupSave = 'Save planogram group',
	PlanogramGroupSeparate = 'Separate planogram group',
	PlanogramGroupUpdate = 'Update planogram group',
	PlanogramLostSaleAnalysis = 'Lost sales analysis stand view',
	PlanogramMultiComplectationFromList = 'Multi stands equipments from planogram list',
	PlanogramMultiComplectationFromPlan = 'Multi stands equipments from plan view',
	PlanogramRevert = 'Stand revert',
	PlanogramShelfStockAnalysis = 'Shelf stock analysis stand view',
	PlanogramSquareAnalysis = 'Square analysis stand view',
	PlanSquareAnalysis = 'Square analysis plan view',
	PlanVisitorHeatmap = 'Visitor heatmap plan view',
	POSCreate = 'Create POS',
	POSDelete = 'Delete POS',
	POSAdd = 'Add POS to planogram',
	POSDeleteFromPlanogram = 'Delete POS from planogram',
	POSTextAdd = 'Add text to planogram',
	POSTextDelete = 'Delete text from planogram',
	ProductsArchive = 'Products archive',
	ProductsUnarchive = 'Products unarchive',
	ProductsPage = 'Products page',
	ProductsParamsRevert = 'Revert product params',
	ProductsUpdating = 'Updating products',
	ProductLayoutExcel = 'Download excel on product layout',
	RedirectToEquipment = 'Redirect to equipment',
	RedirectToPlan = 'Redirect to plan',
	ReturnPhotoReportsFromControl = 'Returned photo reports on control',
	ReturnPhotoReportsFromPlanogram = 'Returned photo reports on stand view',
	RotationFromPlanList = 'Rotation on plan list',
	RotationFromPlanogramList = 'Rotation on stand list',
	SendExecutionFromPlanEdit = 'Send for execution on plan edit',
	SendExecutionFromPlanogramEdit = 'Send for execution on stand edit',
	SendExecutionFromPlanogramList = 'Send for execution on stand list',
	TariffComparison = 'Tariff comparison page',
	TasksPage = 'Tasks page',
	TimeTrackerContinue = 'Time tracking continue',
	TimeTrackerPause = 'Time tracking pause',
	TimeTrackerStart = 'Time tracking start',
	TransparentBoxes = 'Open transparent boxes mode',
	WhatNew = 'Open What\'s new',
	ChatOpened = 'Chat Opened',
	MessageSent = 'Chat Message Sent',
	MessageReplied = 'Chat Message Replied'
}